/**
 * Regeln für die Projekt- und Datenstand-Anzeigen.
 * - Ziel in Gefahr: Erwartung Jahresende (Ist + Forecast ab laufendem Monat) liegt mehr als 3 % unter dem Ziel.
 * - Datenstand: jede Quelle hat eine erwartete Taktung; wird sie überschritten, ist der Stand „alt“ bzw. „veraltet“.
 */
/** Spielraum, bis eine Erwartung unter Ziel als „Ziel in Gefahr“ gilt (3 % des Ziels). */
export const GOAL_RISK_TOLERANCE = 0.03;
/** true = Ziel laut Forecast deutlich verfehlt. Ohne Ziel oder ohne Erwartung: false. */
export function goalAtRisk(targetCents, expectedCents) {
    if (!targetCents || targetCents <= 0 || expectedCents === null)
        return false;
    return expectedCents < targetCents * (1 - GOAL_RISK_TOLERANCE);
}
/** Arbeitstage (Mo–Fr) zwischen zwei Zeitpunkten, Tag des letzten Laufs nicht mitgezählt. */
export function workdaysBetween(from, to) {
    const d = new Date(Date.UTC(from.getUTCFullYear(), from.getUTCMonth(), from.getUTCDate()));
    const end = Date.UTC(to.getUTCFullYear(), to.getUTCMonth(), to.getUTCDate());
    let n = 0;
    while (d.getTime() < end) {
        d.setUTCDate(d.getUTCDate() + 1);
        const wd = d.getUTCDay();
        if (wd !== 0 && wd !== 6)
            n++;
    }
    return n;
}
/** Abgleiche, die täglich (Mo–Fr) laufen sollen: ab 3 Arbeitstagen alt, ab 6 veraltet. */
export const SYNC_OLD_DAYS = 3;
export const SYNC_STALE_DAYS = 6;
export function syncFreshness(key, at, now) {
    if (!at)
        return { key, at: null, lastMonth: null, state: 'none', ageDays: null, missingMonth: null };
    const age = workdaysBetween(new Date(at), now);
    return { key, at, lastMonth: null, state: age >= SYNC_STALE_DAYS ? 'stale' : age >= SYNC_OLD_DAYS ? 'old' : 'ok', ageDays: age, missingMonth: null };
}
/** Monatliche Exporte (Power BI): fehlt der abgeschlossene Vormonat, ist der Stand alt; fehlen zwei Monate, veraltet. */
export function monthFreshness(key, at, lastMonth, now) {
    if (!at || !lastMonth)
        return { key, at, lastMonth, state: 'none', ageDays: null, missingMonth: null };
    const prev = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - 1, 1));
    const prevKey = `${prev.getUTCFullYear()}-${String(prev.getUTCMonth() + 1).padStart(2, '0')}`;
    const [y, m] = lastMonth.split('-').map(Number);
    const gap = (prev.getUTCFullYear() - y) * 12 + (prev.getUTCMonth() + 1 - m);
    const age = workdaysBetween(new Date(at), now);
    return { key, at, lastMonth, state: gap >= 2 ? 'stale' : gap === 1 ? 'old' : 'ok', ageDays: age, missingMonth: gap >= 1 ? prevKey : null };
}
/** Schlechtester Zustand einer Liste (für die Kopfzeile). */
export function worstFreshness(xs) {
    if (xs.some((x) => x.state === 'stale'))
        return 'stale';
    if (xs.some((x) => x.state === 'old'))
        return 'old';
    return 'ok';
}
//# sourceMappingURL=status.js.map